module.exports = __webpack_public_path__ + "static/media/HCMM136.8cf1b8f5.jpg";